import {
  CREATE_JOB_CARD_CLOSURE_SUCCESS,
  FETCH_JOB_CARD_CLOSURE_SUCCESS,
  GET_JOB_CARD_CLOSURE_SUCCESS,
  SAVE_JOB_CARD_CLOSURE_QUERY,
} from '../../constants/ActionTypes';

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_JOB_CARD_CLOSURE_QUERY: {
      return {
        ...state,
        query: action.query,
      };
    }

    case GET_JOB_CARD_CLOSURE_SUCCESS: {
      const query = { ...state.query };
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      };
    }

    case CREATE_JOB_CARD_CLOSURE_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      };
    }

    case FETCH_JOB_CARD_CLOSURE_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      };
    }


    default:
      return state;
  }
}
